import { cancelOffer as _cancelOffer } from 'src/thirdweb/dotc'
import useDotcContract from './useDotcContract'

const useCancelOffer = () => {
  const dotcContract = useDotcContract()

  const cancelOffer = (offerId: string) => {
    if (!dotcContract) return

    const cancelOfferTx = _cancelOffer({
      contract: dotcContract,
      offerId: BigInt(offerId),
    })

    return cancelOfferTx
  }

  return cancelOffer
}

export default useCancelOffer
